<template>
  <div class="audit-reference" v-if="items.length">
    <div class="detail">
      <span class="title">审核参照数据</span>
      <div class="item" v-for="(item, index) in items" :key="index">
        <span class="label">{{ item.key }}</span>
        <span class="value">{{ item.value || '-' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TaskAuditReferenceDetail',
  computed: {
    ...Vuex.mapState({
      taskAuditReference: state => state.orderReview.taskAuditReference,
    }),
    items () {
      return (this.taskAuditReference && this.taskAuditReference.items) || []
    },
  },
}
</script>

<style scoped>
.audit-reference {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.detail {
  background-color: #ecf5ff;
  padding: 8px;
  border-radius: 6px;
}
.title {
  display: inline-block;
  margin-top: 4px;
  font-size: 14px;
  font-weight: bold;
}
.item {
  margin: 8px 0;
  display: flex;
  flex-direction: row;
}
.label {
  display: inline-block;
  font-size: 14px;
  width: 110px;
  flex-shrink: 0;
  color: #666;
}
.value {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/TaskAuditReferenceDetail.vue